import { render, staticRenderFns } from "./SwipeBanner.vue?vue&type=template&id=cec5e0d8&scoped=true&"
import script from "./SwipeBanner.vue?vue&type=script&lang=js&"
export * from "./SwipeBanner.vue?vue&type=script&lang=js&"
import style0 from "./SwipeBanner.vue?vue&type=style&index=0&id=cec5e0d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec5e0d8",
  null
  
)

export default component.exports